export default "__VITE_ASSET__Dk7l_weZ__"